export const BRIDGE_DOWNLOAD_URL = 'https://bridge.surf/download';
export const OPEN_BRIDGE_DEEPLINK_TIMEOUT_MS = 1500;

type OpenBridgeChatDeepLinkOptions = {
  fallbackURL?: string;
  openDeepLink?: (url: string) => void;
  openFallback?: (url: string) => void;
  scheme?: string;
  targetWindow?: Window;
  timeoutMs?: number;
};

export function bridgeChatDeepLinkScheme() {
  return process.env.NODE_ENV === 'development' ? 'bridge-dev' : 'bridge';
}

export function buildBridgeChatDeepLinkURL(
  scheme = bridgeChatDeepLinkScheme()
) {
  return `${scheme}://chat`;
}

export function openBridgeChatDeepLinkWithFallback({
  fallbackURL = BRIDGE_DOWNLOAD_URL,
  openDeepLink,
  openFallback,
  scheme,
  targetWindow = window,
  timeoutMs = OPEN_BRIDGE_DEEPLINK_TIMEOUT_MS,
}: OpenBridgeChatDeepLinkOptions = {}) {
  const deepLinkURL = buildBridgeChatDeepLinkURL(scheme);
  let didBlur = false;

  const handleWindowBlur = () => {
    didBlur = true;
  };

  targetWindow.addEventListener('blur', handleWindowBlur);

  const fallbackTimer = targetWindow.setTimeout(() => {
    targetWindow.removeEventListener('blur', handleWindowBlur);
    if (!didBlur) {
      if (openFallback) {
        openFallback(fallbackURL);
        return;
      }
      targetWindow.location.assign(fallbackURL);
    }
  }, timeoutMs);

  try {
    if (openDeepLink) {
      openDeepLink(deepLinkURL);
    } else {
      targetWindow.location.href = deepLinkURL;
    }
  } catch {
    targetWindow.clearTimeout(fallbackTimer);
    targetWindow.removeEventListener('blur', handleWindowBlur);
    if (openFallback) {
      openFallback(fallbackURL);
      return;
    }
    targetWindow.location.assign(fallbackURL);
  }
}
